import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwConsentContainer extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            toggleElementClassName: "auw_consent_toggle",
            ttl:0.0007,
        }
    }

    __PageReady(){
        console.log(this.config);
        this.$el.find('.'+this.config.toggleElementClassName).first().on("click",this.setCookieAndReload.bind(this));
    }

    setCookieAndReload(e){
        e.preventDefault();
        e.stopPropagation();
        this.$el.addClass("loading");
        this.createCookie(this.config.cookieName,1,this.config.ttl);
        const tmpUrl = document.URL.replace(/#.*$/, "")+(this.config.targetElementAnchorId ? '#consent_accepted_content_'+this.config.targetElementAnchorId:'');
        location.replace(tmpUrl);
        location.reload();
        return false;
    }

}
